'use strict';

import $ from 'jquery';
import { defaultOptions } from './tippy-util';
import mainMenu from './menu-objects/main-menu';
import mainMenuTree from './menu-objects/main-menu-tree';
import mainMenuTabbed from './menu-objects/main-menu-tabbed';

/**
 * @param {JQuery} $menuContainer
 */
const waitForDesktop = ($menuContainer) => {

	// Detect window size
	const mqDesktop = window.matchMedia('(min-width: 992px)');
	const handleMediaDropdownChange = (e) => {
		// Check if the media query is true
		if (e.matches) {
			mqDesktop.removeEventListener('change', handleMediaDropdownChange);
			initOnce($menuContainer);
		}
	};
	// Register event listener
	mqDesktop.addEventListener('change', handleMediaDropdownChange);
	// Initial check
	handleMediaDropdownChange(mqDesktop);
};

/**
 * @param {JQuery} $menuContainer
 */
const initOnce = async ($menuContainer) => {

	// Import the tippy singleton lib lazily
	const { createSingleton } = await import('tippy.js');
	// Init tree menu
	const treeLevels = [
		'.header__menu-content--tree .menu-tree--level-3 > .menu-tree__item > [data-target]',
		'.header__menu-content--tree .menu-tree--level-2 > .menu-tree__item > [data-target]',
		'.header__menu-content--tree .menu-tree--level-1 > .menu-tree__item > [data-target]',
		'.header__menu-content--tree .menu-tree--level-0 > .menu-tree__item > [data-target]',
	];

	const menuDirection = $menuContainer.is('[data-menu-vertical]') ? 'vertical' : 'horizontal';

	for (const treeLevel of treeLevels) {
		let tippyInstances = [];
		const $treeLevelTriggers = $menuContainer.find(treeLevel);

		if ($treeLevelTriggers.length > 0) {
			for (const treeLevelTrigger of $treeLevelTriggers) {
				const $menu = $(treeLevelTrigger);
				const $content = $menuContainer.find(`#${$menu.data('target')}`);

				tippyInstances.push(
					// @ts-ignore
					await mainMenuTree($menu, $menuContainer, $content, menuDirection, {})
				);
			}
		}

		// Link all tree menus for current level
		// @ts-ignore
		createSingleton(tippyInstances, {
			// @ts-ignore
			overrides: [...Object.keys(defaultOptions), 'appendTo', 'content', 'placement', 'onTrigger', 'onUntrigger'],
		});
	}

	// Init tabbed menu
	const $tabbedMenus = $menuContainer.find('.header__menu-content--tabbed .menu-tabbed .menu-tabbed__index');

	if ($tabbedMenus.length > 0) {
		for (const tabbedMenu of $tabbedMenus) {

			const $tab = $(tabbedMenu);
			const $tabbedMenusItems = $tab.find('.menu-tabbed__item > [data-target]');
			const $tabbedExpandedContent = $tab.closest('.menu-tabbed').find('.menu-tabbed__expanded-content');

			let tabbedMenusInstances = [];

			for (const tabbedMenusItem of $tabbedMenusItems) {
				const $menu = $(tabbedMenusItem);
				const $content = $menuContainer.find(`#${$menu.data('target')}`);

				tabbedMenusInstances.push(
					// @ts-ignore
					await mainMenuTabbed($tab, $menu, $tabbedExpandedContent, $menuContainer, $content, menuDirection, {
						onMount: (instance, event) => {
							tabbedMenusInstances.forEach((currentInstance) => {
								if (instance !== currentInstance) {
									currentInstance.unmount();
								}
							});
						},
					})
				);
			}
		}
	}

	// Init main menu
	const $firstLevelMenus = $menuContainer.find('.header__menu-list > [data-target]');

	if ($firstLevelMenus.length > 0) {

		for (const firstLevelMenu of $firstLevelMenus) {

			const $menu = $(firstLevelMenu);
			const $content = $menuContainer.find(`#${$menu.data('target')}`);

			if ($content.length) {
				await mainMenu($menu, $menuContainer, $content, menuDirection, {});
			}
		}
	}
};

/**
 * @param {JQuery} $container
 */
export default async ($container) => {

	// Get the tippy container
	const $menuContainer = $container.find('[data-menu-container]').length ? $container.find('[data-menu-container]') : $container.find('#header');

	if ($menuContainer.length > 0) {

		// Load the menu library only on a desktop device
		waitForDesktop($menuContainer);
	}
};
